import { createActions } from 'reduxsauce';
import { removeSelectedItem } from '@iso/lib//helpers/CRUD';

export const { Types: types, Creators: actions } = createActions({
    requestDeleteCurrency: ['id'],
    deleteCurrencySucceeded: ['id'],
    deleteCurrencyFailed: ['error'],
});

export default {
    [types.REQUEST_DELETE_CURRENCY]: (state, { id }) => ({
        ...state,
        delete: {
            ...state.delete,
            id,
            loading: true,
            error: null,
        },
    }),
    [types.DELETE_CURRENCY_SUCCEEDED]: (state, { id }) => ({
        ...state,
        data: removeSelectedItem(state.data, id),
        delete: {
            ...state.delete,
            id: null,
            loading: false,
        },
    }),
    [types.DELETE_CURRENCY_FAILED]: (state, { error }) => ({
        ...state,
        delete: {
            ...state.delete,
            id: null,
            loading: false,
            error,
        },
    }),
};
